/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as RestablecerContrasenaRouteImport } from "./routes/restablecer-contrasena"
import { Route as RecuperarContrasenaRouteImport } from "./routes/recuperar-contrasena"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as AuthedTwRouteImport } from "./routes/_authed-tw"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as AuthedTwReporteriaRouteImport } from "./routes/_authed-tw/reporteria"
import { Route as AuthedTwPerfilRouteImport } from "./routes/_authed-tw/perfil"
import { Route as AuthedTwHistoricoDocumentalRouteImport } from "./routes/_authed-tw/historico-documental"
import { Route as AuthedTwFacturasRouteImport } from "./routes/_authed-tw/facturas"
import { Route as AuthedTwDashboardRouteImport } from "./routes/_authed-tw/dashboard"
import { Route as AuthedTwContrapagosPendientesRouteImport } from "./routes/_authed-tw/contrapagos-pendientes"
import { Route as AuthedTwCalendarioPagosRouteImport } from "./routes/_authed-tw/calendario-pagos"
import { Route as AuthedTwSolicitudesIndexRouteImport } from "./routes/_authed-tw/solicitudes/index"
import { Route as AuthedTwAdminIndexRouteImport } from "./routes/_authed-tw/admin/index"
import { Route as AuthedTwSolicitudesNuevaRouteImport } from "./routes/_authed-tw/solicitudes/nueva"
import { Route as AuthedTwAutorizacionHistorialRouteImport } from "./routes/_authed-tw/autorizacion/historial"
import { Route as AuthedTwAutorizacionBandejaRouteImport } from "./routes/_authed-tw/autorizacion/bandeja"
import { Route as AuthedTwAutorizacionIdRouteImport } from "./routes/_authed-tw/autorizacion/$id"
import { Route as AuthedTwAdminUsuariosRouteImport } from "./routes/_authed-tw/admin/usuarios"
import { Route as AuthedTwAdminTiposDocumentoRouteImport } from "./routes/_authed-tw/admin/tipos-documento"
import { Route as AuthedTwAdminSolicitudesCatalogoRouteImport } from "./routes/_authed-tw/admin/solicitudes-catalogo"
import { Route as AuthedTwAdminRolesRouteImport } from "./routes/_authed-tw/admin/roles"
import { Route as AuthedTwAdminReporteriaRouteImport } from "./routes/_authed-tw/admin/reporteria"
import { Route as AuthedTwAdminProveedoresRouteImport } from "./routes/_authed-tw/admin/proveedores"
import { Route as AuthedTwAdminPermisosRouteImport } from "./routes/_authed-tw/admin/permisos"
import { Route as AuthedTwAdminOrganizacionesRouteImport } from "./routes/_authed-tw/admin/organizaciones"
import { Route as AuthedTwAdminMapeosClaveCuentaRouteImport } from "./routes/_authed-tw/admin/mapeos-clave-cuenta"
import { Route as AuthedTwAdminIndicadoresImpuestoRouteImport } from "./routes/_authed-tw/admin/indicadores-impuesto"
import { Route as AuthedTwAdminFlujosAutorizacionRouteImport } from "./routes/_authed-tw/admin/flujos-autorizacion"
import { Route as AuthedTwAdminEquivalenciasUnidadRouteImport } from "./routes/_authed-tw/admin/equivalencias-unidad"
import { Route as AuthedTwAdminConfiguracionesRouteImport } from "./routes/_authed-tw/admin/configuraciones"
import { Route as AuthedTwAdminCategoriasDocumentoRouteImport } from "./routes/_authed-tw/admin/categorias-documento"
import { Route as AuthedTwAdminCatalogosSatRouteImport } from "./routes/_authed-tw/admin/catalogos-sat"
import { Route as AuthedTwAdminCatalogosContablesRouteImport } from "./routes/_authed-tw/admin/catalogos-contables"
import { Route as AuthedTwAdminAuditoriaRouteImport } from "./routes/_authed-tw/admin/auditoria"
import { Route as AuthedTwAdminAreasRouteImport } from "./routes/_authed-tw/admin/areas"
import { Route as AuthedTwSolicitudesIdIndexRouteImport } from "./routes/_authed-tw/solicitudes/$id/index"
import { Route as AuthedTwAdminOrdenesCompraIndexRouteImport } from "./routes/_authed-tw/admin/ordenes-compra/index"
import { Route as AuthedTwAdminContratosAnualizadosIndexRouteImport } from "./routes/_authed-tw/admin/contratos-anualizados/index"
import { Route as AuthedTwSolicitudesIdProveedorManualRouteImport } from "./routes/_authed-tw/solicitudes/$id/proveedor-manual"
import { Route as AuthedTwSolicitudesIdProveedorRouteImport } from "./routes/_authed-tw/solicitudes/$id/proveedor"
import { Route as AuthedTwSolicitudesIdProrrateoSinCfdiRouteImport } from "./routes/_authed-tw/solicitudes/$id/prorrateo-sin-cfdi"
import { Route as AuthedTwSolicitudesIdProrrateoMultipleRouteImport } from "./routes/_authed-tw/solicitudes/$id/prorrateo-multiple"
import { Route as AuthedTwSolicitudesIdProrrateoRouteImport } from "./routes/_authed-tw/solicitudes/$id/prorrateo"
import { Route as AuthedTwSolicitudesIdOrganizacionManualRouteImport } from "./routes/_authed-tw/solicitudes/$id/organizacion-manual"
import { Route as AuthedTwSolicitudesIdOrdenCompraRouteImport } from "./routes/_authed-tw/solicitudes/$id/orden-compra"
import { Route as AuthedTwSolicitudesIdHistorialRouteImport } from "./routes/_authed-tw/solicitudes/$id/historial"
import { Route as AuthedTwSolicitudesIdDocumentosRouteImport } from "./routes/_authed-tw/solicitudes/$id/documentos"
import { Route as AuthedTwSolicitudesIdDatosGeneralesRouteImport } from "./routes/_authed-tw/solicitudes/$id/datos-generales"
import { Route as AuthedTwSolicitudesIdContratoAnualizadoRouteImport } from "./routes/_authed-tw/solicitudes/$id/contrato-anualizado"
import { Route as AuthedTwSolicitudesIdContabilizacionRouteImport } from "./routes/_authed-tw/solicitudes/$id/contabilizacion"
import { Route as AuthedTwSolicitudesIdConciliarCfdiRouteImport } from "./routes/_authed-tw/solicitudes/$id/conciliar-cfdi"
import { Route as AuthedTwSolicitudesIdCargarZipRouteImport } from "./routes/_authed-tw/solicitudes/$id/cargar-zip"
import { Route as AuthedTwSolicitudesIdCargarCfdiRouteImport } from "./routes/_authed-tw/solicitudes/$id/cargar-cfdi"
import { Route as AuthedTwSolicitudesIdCargaInvoiceRouteImport } from "./routes/_authed-tw/solicitudes/$id/carga-invoice"
import { Route as AuthedTwSolicitudesIdAutorizacionRouteImport } from "./routes/_authed-tw/solicitudes/$id/autorizacion"
import { Route as AuthedTwAdminOrdenesCompraIdRouteImport } from "./routes/_authed-tw/admin/ordenes-compra/$id"
import { Route as AuthedTwAdminContratosAnualizadosIdRouteImport } from "./routes/_authed-tw/admin/contratos-anualizados/$id"

const RestablecerContrasenaRoute = RestablecerContrasenaRouteImport.update({
  id: "/restablecer-contrasena",
  path: "/restablecer-contrasena",
  getParentRoute: () => rootRouteImport,
} as any)
const RecuperarContrasenaRoute = RecuperarContrasenaRouteImport.update({
  id: "/recuperar-contrasena",
  path: "/recuperar-contrasena",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTwRoute = AuthedTwRouteImport.update({
  id: "/_authed-tw",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTwReporteriaRoute = AuthedTwReporteriaRouteImport.update({
  id: "/reporteria",
  path: "/reporteria",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwPerfilRoute = AuthedTwPerfilRouteImport.update({
  id: "/perfil",
  path: "/perfil",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwHistoricoDocumentalRoute =
  AuthedTwHistoricoDocumentalRouteImport.update({
    id: "/historico-documental",
    path: "/historico-documental",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwFacturasRoute = AuthedTwFacturasRouteImport.update({
  id: "/facturas",
  path: "/facturas",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwDashboardRoute = AuthedTwDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwContrapagosPendientesRoute =
  AuthedTwContrapagosPendientesRouteImport.update({
    id: "/contrapagos-pendientes",
    path: "/contrapagos-pendientes",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwCalendarioPagosRoute = AuthedTwCalendarioPagosRouteImport.update({
  id: "/calendario-pagos",
  path: "/calendario-pagos",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwSolicitudesIndexRoute =
  AuthedTwSolicitudesIndexRouteImport.update({
    id: "/solicitudes/",
    path: "/solicitudes/",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminIndexRoute = AuthedTwAdminIndexRouteImport.update({
  id: "/admin/",
  path: "/admin/",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwSolicitudesNuevaRoute =
  AuthedTwSolicitudesNuevaRouteImport.update({
    id: "/solicitudes/nueva",
    path: "/solicitudes/nueva",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAutorizacionHistorialRoute =
  AuthedTwAutorizacionHistorialRouteImport.update({
    id: "/autorizacion/historial",
    path: "/autorizacion/historial",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAutorizacionBandejaRoute =
  AuthedTwAutorizacionBandejaRouteImport.update({
    id: "/autorizacion/bandeja",
    path: "/autorizacion/bandeja",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAutorizacionIdRoute = AuthedTwAutorizacionIdRouteImport.update({
  id: "/autorizacion/$id",
  path: "/autorizacion/$id",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwAdminUsuariosRoute = AuthedTwAdminUsuariosRouteImport.update({
  id: "/admin/usuarios",
  path: "/admin/usuarios",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwAdminTiposDocumentoRoute =
  AuthedTwAdminTiposDocumentoRouteImport.update({
    id: "/admin/tipos-documento",
    path: "/admin/tipos-documento",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminSolicitudesCatalogoRoute =
  AuthedTwAdminSolicitudesCatalogoRouteImport.update({
    id: "/admin/solicitudes-catalogo",
    path: "/admin/solicitudes-catalogo",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminRolesRoute = AuthedTwAdminRolesRouteImport.update({
  id: "/admin/roles",
  path: "/admin/roles",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwAdminReporteriaRoute = AuthedTwAdminReporteriaRouteImport.update({
  id: "/admin/reporteria",
  path: "/admin/reporteria",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwAdminProveedoresRoute =
  AuthedTwAdminProveedoresRouteImport.update({
    id: "/admin/proveedores",
    path: "/admin/proveedores",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminPermisosRoute = AuthedTwAdminPermisosRouteImport.update({
  id: "/admin/permisos",
  path: "/admin/permisos",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwAdminOrganizacionesRoute =
  AuthedTwAdminOrganizacionesRouteImport.update({
    id: "/admin/organizaciones",
    path: "/admin/organizaciones",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminMapeosClaveCuentaRoute =
  AuthedTwAdminMapeosClaveCuentaRouteImport.update({
    id: "/admin/mapeos-clave-cuenta",
    path: "/admin/mapeos-clave-cuenta",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminIndicadoresImpuestoRoute =
  AuthedTwAdminIndicadoresImpuestoRouteImport.update({
    id: "/admin/indicadores-impuesto",
    path: "/admin/indicadores-impuesto",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminFlujosAutorizacionRoute =
  AuthedTwAdminFlujosAutorizacionRouteImport.update({
    id: "/admin/flujos-autorizacion",
    path: "/admin/flujos-autorizacion",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminEquivalenciasUnidadRoute =
  AuthedTwAdminEquivalenciasUnidadRouteImport.update({
    id: "/admin/equivalencias-unidad",
    path: "/admin/equivalencias-unidad",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminConfiguracionesRoute =
  AuthedTwAdminConfiguracionesRouteImport.update({
    id: "/admin/configuraciones",
    path: "/admin/configuraciones",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminCategoriasDocumentoRoute =
  AuthedTwAdminCategoriasDocumentoRouteImport.update({
    id: "/admin/categorias-documento",
    path: "/admin/categorias-documento",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminCatalogosSatRoute =
  AuthedTwAdminCatalogosSatRouteImport.update({
    id: "/admin/catalogos-sat",
    path: "/admin/catalogos-sat",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminCatalogosContablesRoute =
  AuthedTwAdminCatalogosContablesRouteImport.update({
    id: "/admin/catalogos-contables",
    path: "/admin/catalogos-contables",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminAuditoriaRoute = AuthedTwAdminAuditoriaRouteImport.update({
  id: "/admin/auditoria",
  path: "/admin/auditoria",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwAdminAreasRoute = AuthedTwAdminAreasRouteImport.update({
  id: "/admin/areas",
  path: "/admin/areas",
  getParentRoute: () => AuthedTwRoute,
} as any)
const AuthedTwSolicitudesIdIndexRoute =
  AuthedTwSolicitudesIdIndexRouteImport.update({
    id: "/solicitudes/$id/",
    path: "/solicitudes/$id/",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminOrdenesCompraIndexRoute =
  AuthedTwAdminOrdenesCompraIndexRouteImport.update({
    id: "/admin/ordenes-compra/",
    path: "/admin/ordenes-compra/",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminContratosAnualizadosIndexRoute =
  AuthedTwAdminContratosAnualizadosIndexRouteImport.update({
    id: "/admin/contratos-anualizados/",
    path: "/admin/contratos-anualizados/",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdProveedorManualRoute =
  AuthedTwSolicitudesIdProveedorManualRouteImport.update({
    id: "/solicitudes/$id/proveedor-manual",
    path: "/solicitudes/$id/proveedor-manual",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdProveedorRoute =
  AuthedTwSolicitudesIdProveedorRouteImport.update({
    id: "/solicitudes/$id/proveedor",
    path: "/solicitudes/$id/proveedor",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdProrrateoSinCfdiRoute =
  AuthedTwSolicitudesIdProrrateoSinCfdiRouteImport.update({
    id: "/solicitudes/$id/prorrateo-sin-cfdi",
    path: "/solicitudes/$id/prorrateo-sin-cfdi",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdProrrateoMultipleRoute =
  AuthedTwSolicitudesIdProrrateoMultipleRouteImport.update({
    id: "/solicitudes/$id/prorrateo-multiple",
    path: "/solicitudes/$id/prorrateo-multiple",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdProrrateoRoute =
  AuthedTwSolicitudesIdProrrateoRouteImport.update({
    id: "/solicitudes/$id/prorrateo",
    path: "/solicitudes/$id/prorrateo",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdOrganizacionManualRoute =
  AuthedTwSolicitudesIdOrganizacionManualRouteImport.update({
    id: "/solicitudes/$id/organizacion-manual",
    path: "/solicitudes/$id/organizacion-manual",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdOrdenCompraRoute =
  AuthedTwSolicitudesIdOrdenCompraRouteImport.update({
    id: "/solicitudes/$id/orden-compra",
    path: "/solicitudes/$id/orden-compra",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdHistorialRoute =
  AuthedTwSolicitudesIdHistorialRouteImport.update({
    id: "/solicitudes/$id/historial",
    path: "/solicitudes/$id/historial",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdDocumentosRoute =
  AuthedTwSolicitudesIdDocumentosRouteImport.update({
    id: "/solicitudes/$id/documentos",
    path: "/solicitudes/$id/documentos",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdDatosGeneralesRoute =
  AuthedTwSolicitudesIdDatosGeneralesRouteImport.update({
    id: "/solicitudes/$id/datos-generales",
    path: "/solicitudes/$id/datos-generales",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdContratoAnualizadoRoute =
  AuthedTwSolicitudesIdContratoAnualizadoRouteImport.update({
    id: "/solicitudes/$id/contrato-anualizado",
    path: "/solicitudes/$id/contrato-anualizado",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdContabilizacionRoute =
  AuthedTwSolicitudesIdContabilizacionRouteImport.update({
    id: "/solicitudes/$id/contabilizacion",
    path: "/solicitudes/$id/contabilizacion",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdConciliarCfdiRoute =
  AuthedTwSolicitudesIdConciliarCfdiRouteImport.update({
    id: "/solicitudes/$id/conciliar-cfdi",
    path: "/solicitudes/$id/conciliar-cfdi",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdCargarZipRoute =
  AuthedTwSolicitudesIdCargarZipRouteImport.update({
    id: "/solicitudes/$id/cargar-zip",
    path: "/solicitudes/$id/cargar-zip",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdCargarCfdiRoute =
  AuthedTwSolicitudesIdCargarCfdiRouteImport.update({
    id: "/solicitudes/$id/cargar-cfdi",
    path: "/solicitudes/$id/cargar-cfdi",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdCargaInvoiceRoute =
  AuthedTwSolicitudesIdCargaInvoiceRouteImport.update({
    id: "/solicitudes/$id/carga-invoice",
    path: "/solicitudes/$id/carga-invoice",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwSolicitudesIdAutorizacionRoute =
  AuthedTwSolicitudesIdAutorizacionRouteImport.update({
    id: "/solicitudes/$id/autorizacion",
    path: "/solicitudes/$id/autorizacion",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminOrdenesCompraIdRoute =
  AuthedTwAdminOrdenesCompraIdRouteImport.update({
    id: "/admin/ordenes-compra/$id",
    path: "/admin/ordenes-compra/$id",
    getParentRoute: () => AuthedTwRoute,
  } as any)
const AuthedTwAdminContratosAnualizadosIdRoute =
  AuthedTwAdminContratosAnualizadosIdRouteImport.update({
    id: "/admin/contratos-anualizados/$id",
    path: "/admin/contratos-anualizados/$id",
    getParentRoute: () => AuthedTwRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/recuperar-contrasena": typeof RecuperarContrasenaRoute
  "/restablecer-contrasena": typeof RestablecerContrasenaRoute
  "/calendario-pagos": typeof AuthedTwCalendarioPagosRoute
  "/contrapagos-pendientes": typeof AuthedTwContrapagosPendientesRoute
  "/dashboard": typeof AuthedTwDashboardRoute
  "/facturas": typeof AuthedTwFacturasRoute
  "/historico-documental": typeof AuthedTwHistoricoDocumentalRoute
  "/perfil": typeof AuthedTwPerfilRoute
  "/reporteria": typeof AuthedTwReporteriaRoute
  "/admin/areas": typeof AuthedTwAdminAreasRoute
  "/admin/auditoria": typeof AuthedTwAdminAuditoriaRoute
  "/admin/catalogos-contables": typeof AuthedTwAdminCatalogosContablesRoute
  "/admin/catalogos-sat": typeof AuthedTwAdminCatalogosSatRoute
  "/admin/categorias-documento": typeof AuthedTwAdminCategoriasDocumentoRoute
  "/admin/configuraciones": typeof AuthedTwAdminConfiguracionesRoute
  "/admin/equivalencias-unidad": typeof AuthedTwAdminEquivalenciasUnidadRoute
  "/admin/flujos-autorizacion": typeof AuthedTwAdminFlujosAutorizacionRoute
  "/admin/indicadores-impuesto": typeof AuthedTwAdminIndicadoresImpuestoRoute
  "/admin/mapeos-clave-cuenta": typeof AuthedTwAdminMapeosClaveCuentaRoute
  "/admin/organizaciones": typeof AuthedTwAdminOrganizacionesRoute
  "/admin/permisos": typeof AuthedTwAdminPermisosRoute
  "/admin/proveedores": typeof AuthedTwAdminProveedoresRoute
  "/admin/reporteria": typeof AuthedTwAdminReporteriaRoute
  "/admin/roles": typeof AuthedTwAdminRolesRoute
  "/admin/solicitudes-catalogo": typeof AuthedTwAdminSolicitudesCatalogoRoute
  "/admin/tipos-documento": typeof AuthedTwAdminTiposDocumentoRoute
  "/admin/usuarios": typeof AuthedTwAdminUsuariosRoute
  "/autorizacion/$id": typeof AuthedTwAutorizacionIdRoute
  "/autorizacion/bandeja": typeof AuthedTwAutorizacionBandejaRoute
  "/autorizacion/historial": typeof AuthedTwAutorizacionHistorialRoute
  "/solicitudes/nueva": typeof AuthedTwSolicitudesNuevaRoute
  "/admin/": typeof AuthedTwAdminIndexRoute
  "/solicitudes/": typeof AuthedTwSolicitudesIndexRoute
  "/admin/contratos-anualizados/$id": typeof AuthedTwAdminContratosAnualizadosIdRoute
  "/admin/ordenes-compra/$id": typeof AuthedTwAdminOrdenesCompraIdRoute
  "/solicitudes/$id/autorizacion": typeof AuthedTwSolicitudesIdAutorizacionRoute
  "/solicitudes/$id/carga-invoice": typeof AuthedTwSolicitudesIdCargaInvoiceRoute
  "/solicitudes/$id/cargar-cfdi": typeof AuthedTwSolicitudesIdCargarCfdiRoute
  "/solicitudes/$id/cargar-zip": typeof AuthedTwSolicitudesIdCargarZipRoute
  "/solicitudes/$id/conciliar-cfdi": typeof AuthedTwSolicitudesIdConciliarCfdiRoute
  "/solicitudes/$id/contabilizacion": typeof AuthedTwSolicitudesIdContabilizacionRoute
  "/solicitudes/$id/contrato-anualizado": typeof AuthedTwSolicitudesIdContratoAnualizadoRoute
  "/solicitudes/$id/datos-generales": typeof AuthedTwSolicitudesIdDatosGeneralesRoute
  "/solicitudes/$id/documentos": typeof AuthedTwSolicitudesIdDocumentosRoute
  "/solicitudes/$id/historial": typeof AuthedTwSolicitudesIdHistorialRoute
  "/solicitudes/$id/orden-compra": typeof AuthedTwSolicitudesIdOrdenCompraRoute
  "/solicitudes/$id/organizacion-manual": typeof AuthedTwSolicitudesIdOrganizacionManualRoute
  "/solicitudes/$id/prorrateo": typeof AuthedTwSolicitudesIdProrrateoRoute
  "/solicitudes/$id/prorrateo-multiple": typeof AuthedTwSolicitudesIdProrrateoMultipleRoute
  "/solicitudes/$id/prorrateo-sin-cfdi": typeof AuthedTwSolicitudesIdProrrateoSinCfdiRoute
  "/solicitudes/$id/proveedor": typeof AuthedTwSolicitudesIdProveedorRoute
  "/solicitudes/$id/proveedor-manual": typeof AuthedTwSolicitudesIdProveedorManualRoute
  "/admin/contratos-anualizados/": typeof AuthedTwAdminContratosAnualizadosIndexRoute
  "/admin/ordenes-compra/": typeof AuthedTwAdminOrdenesCompraIndexRoute
  "/solicitudes/$id/": typeof AuthedTwSolicitudesIdIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/login": typeof LoginRoute
  "/recuperar-contrasena": typeof RecuperarContrasenaRoute
  "/restablecer-contrasena": typeof RestablecerContrasenaRoute
  "/calendario-pagos": typeof AuthedTwCalendarioPagosRoute
  "/contrapagos-pendientes": typeof AuthedTwContrapagosPendientesRoute
  "/dashboard": typeof AuthedTwDashboardRoute
  "/facturas": typeof AuthedTwFacturasRoute
  "/historico-documental": typeof AuthedTwHistoricoDocumentalRoute
  "/perfil": typeof AuthedTwPerfilRoute
  "/reporteria": typeof AuthedTwReporteriaRoute
  "/admin/areas": typeof AuthedTwAdminAreasRoute
  "/admin/auditoria": typeof AuthedTwAdminAuditoriaRoute
  "/admin/catalogos-contables": typeof AuthedTwAdminCatalogosContablesRoute
  "/admin/catalogos-sat": typeof AuthedTwAdminCatalogosSatRoute
  "/admin/categorias-documento": typeof AuthedTwAdminCategoriasDocumentoRoute
  "/admin/configuraciones": typeof AuthedTwAdminConfiguracionesRoute
  "/admin/equivalencias-unidad": typeof AuthedTwAdminEquivalenciasUnidadRoute
  "/admin/flujos-autorizacion": typeof AuthedTwAdminFlujosAutorizacionRoute
  "/admin/indicadores-impuesto": typeof AuthedTwAdminIndicadoresImpuestoRoute
  "/admin/mapeos-clave-cuenta": typeof AuthedTwAdminMapeosClaveCuentaRoute
  "/admin/organizaciones": typeof AuthedTwAdminOrganizacionesRoute
  "/admin/permisos": typeof AuthedTwAdminPermisosRoute
  "/admin/proveedores": typeof AuthedTwAdminProveedoresRoute
  "/admin/reporteria": typeof AuthedTwAdminReporteriaRoute
  "/admin/roles": typeof AuthedTwAdminRolesRoute
  "/admin/solicitudes-catalogo": typeof AuthedTwAdminSolicitudesCatalogoRoute
  "/admin/tipos-documento": typeof AuthedTwAdminTiposDocumentoRoute
  "/admin/usuarios": typeof AuthedTwAdminUsuariosRoute
  "/autorizacion/$id": typeof AuthedTwAutorizacionIdRoute
  "/autorizacion/bandeja": typeof AuthedTwAutorizacionBandejaRoute
  "/autorizacion/historial": typeof AuthedTwAutorizacionHistorialRoute
  "/solicitudes/nueva": typeof AuthedTwSolicitudesNuevaRoute
  "/admin": typeof AuthedTwAdminIndexRoute
  "/solicitudes": typeof AuthedTwSolicitudesIndexRoute
  "/admin/contratos-anualizados/$id": typeof AuthedTwAdminContratosAnualizadosIdRoute
  "/admin/ordenes-compra/$id": typeof AuthedTwAdminOrdenesCompraIdRoute
  "/solicitudes/$id/autorizacion": typeof AuthedTwSolicitudesIdAutorizacionRoute
  "/solicitudes/$id/carga-invoice": typeof AuthedTwSolicitudesIdCargaInvoiceRoute
  "/solicitudes/$id/cargar-cfdi": typeof AuthedTwSolicitudesIdCargarCfdiRoute
  "/solicitudes/$id/cargar-zip": typeof AuthedTwSolicitudesIdCargarZipRoute
  "/solicitudes/$id/conciliar-cfdi": typeof AuthedTwSolicitudesIdConciliarCfdiRoute
  "/solicitudes/$id/contabilizacion": typeof AuthedTwSolicitudesIdContabilizacionRoute
  "/solicitudes/$id/contrato-anualizado": typeof AuthedTwSolicitudesIdContratoAnualizadoRoute
  "/solicitudes/$id/datos-generales": typeof AuthedTwSolicitudesIdDatosGeneralesRoute
  "/solicitudes/$id/documentos": typeof AuthedTwSolicitudesIdDocumentosRoute
  "/solicitudes/$id/historial": typeof AuthedTwSolicitudesIdHistorialRoute
  "/solicitudes/$id/orden-compra": typeof AuthedTwSolicitudesIdOrdenCompraRoute
  "/solicitudes/$id/organizacion-manual": typeof AuthedTwSolicitudesIdOrganizacionManualRoute
  "/solicitudes/$id/prorrateo": typeof AuthedTwSolicitudesIdProrrateoRoute
  "/solicitudes/$id/prorrateo-multiple": typeof AuthedTwSolicitudesIdProrrateoMultipleRoute
  "/solicitudes/$id/prorrateo-sin-cfdi": typeof AuthedTwSolicitudesIdProrrateoSinCfdiRoute
  "/solicitudes/$id/proveedor": typeof AuthedTwSolicitudesIdProveedorRoute
  "/solicitudes/$id/proveedor-manual": typeof AuthedTwSolicitudesIdProveedorManualRoute
  "/admin/contratos-anualizados": typeof AuthedTwAdminContratosAnualizadosIndexRoute
  "/admin/ordenes-compra": typeof AuthedTwAdminOrdenesCompraIndexRoute
  "/solicitudes/$id": typeof AuthedTwSolicitudesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_authed-tw": typeof AuthedTwRouteWithChildren
  "/login": typeof LoginRoute
  "/recuperar-contrasena": typeof RecuperarContrasenaRoute
  "/restablecer-contrasena": typeof RestablecerContrasenaRoute
  "/_authed-tw/calendario-pagos": typeof AuthedTwCalendarioPagosRoute
  "/_authed-tw/contrapagos-pendientes": typeof AuthedTwContrapagosPendientesRoute
  "/_authed-tw/dashboard": typeof AuthedTwDashboardRoute
  "/_authed-tw/facturas": typeof AuthedTwFacturasRoute
  "/_authed-tw/historico-documental": typeof AuthedTwHistoricoDocumentalRoute
  "/_authed-tw/perfil": typeof AuthedTwPerfilRoute
  "/_authed-tw/reporteria": typeof AuthedTwReporteriaRoute
  "/_authed-tw/admin/areas": typeof AuthedTwAdminAreasRoute
  "/_authed-tw/admin/auditoria": typeof AuthedTwAdminAuditoriaRoute
  "/_authed-tw/admin/catalogos-contables": typeof AuthedTwAdminCatalogosContablesRoute
  "/_authed-tw/admin/catalogos-sat": typeof AuthedTwAdminCatalogosSatRoute
  "/_authed-tw/admin/categorias-documento": typeof AuthedTwAdminCategoriasDocumentoRoute
  "/_authed-tw/admin/configuraciones": typeof AuthedTwAdminConfiguracionesRoute
  "/_authed-tw/admin/equivalencias-unidad": typeof AuthedTwAdminEquivalenciasUnidadRoute
  "/_authed-tw/admin/flujos-autorizacion": typeof AuthedTwAdminFlujosAutorizacionRoute
  "/_authed-tw/admin/indicadores-impuesto": typeof AuthedTwAdminIndicadoresImpuestoRoute
  "/_authed-tw/admin/mapeos-clave-cuenta": typeof AuthedTwAdminMapeosClaveCuentaRoute
  "/_authed-tw/admin/organizaciones": typeof AuthedTwAdminOrganizacionesRoute
  "/_authed-tw/admin/permisos": typeof AuthedTwAdminPermisosRoute
  "/_authed-tw/admin/proveedores": typeof AuthedTwAdminProveedoresRoute
  "/_authed-tw/admin/reporteria": typeof AuthedTwAdminReporteriaRoute
  "/_authed-tw/admin/roles": typeof AuthedTwAdminRolesRoute
  "/_authed-tw/admin/solicitudes-catalogo": typeof AuthedTwAdminSolicitudesCatalogoRoute
  "/_authed-tw/admin/tipos-documento": typeof AuthedTwAdminTiposDocumentoRoute
  "/_authed-tw/admin/usuarios": typeof AuthedTwAdminUsuariosRoute
  "/_authed-tw/autorizacion/$id": typeof AuthedTwAutorizacionIdRoute
  "/_authed-tw/autorizacion/bandeja": typeof AuthedTwAutorizacionBandejaRoute
  "/_authed-tw/autorizacion/historial": typeof AuthedTwAutorizacionHistorialRoute
  "/_authed-tw/solicitudes/nueva": typeof AuthedTwSolicitudesNuevaRoute
  "/_authed-tw/admin/": typeof AuthedTwAdminIndexRoute
  "/_authed-tw/solicitudes/": typeof AuthedTwSolicitudesIndexRoute
  "/_authed-tw/admin/contratos-anualizados/$id": typeof AuthedTwAdminContratosAnualizadosIdRoute
  "/_authed-tw/admin/ordenes-compra/$id": typeof AuthedTwAdminOrdenesCompraIdRoute
  "/_authed-tw/solicitudes/$id/autorizacion": typeof AuthedTwSolicitudesIdAutorizacionRoute
  "/_authed-tw/solicitudes/$id/carga-invoice": typeof AuthedTwSolicitudesIdCargaInvoiceRoute
  "/_authed-tw/solicitudes/$id/cargar-cfdi": typeof AuthedTwSolicitudesIdCargarCfdiRoute
  "/_authed-tw/solicitudes/$id/cargar-zip": typeof AuthedTwSolicitudesIdCargarZipRoute
  "/_authed-tw/solicitudes/$id/conciliar-cfdi": typeof AuthedTwSolicitudesIdConciliarCfdiRoute
  "/_authed-tw/solicitudes/$id/contabilizacion": typeof AuthedTwSolicitudesIdContabilizacionRoute
  "/_authed-tw/solicitudes/$id/contrato-anualizado": typeof AuthedTwSolicitudesIdContratoAnualizadoRoute
  "/_authed-tw/solicitudes/$id/datos-generales": typeof AuthedTwSolicitudesIdDatosGeneralesRoute
  "/_authed-tw/solicitudes/$id/documentos": typeof AuthedTwSolicitudesIdDocumentosRoute
  "/_authed-tw/solicitudes/$id/historial": typeof AuthedTwSolicitudesIdHistorialRoute
  "/_authed-tw/solicitudes/$id/orden-compra": typeof AuthedTwSolicitudesIdOrdenCompraRoute
  "/_authed-tw/solicitudes/$id/organizacion-manual": typeof AuthedTwSolicitudesIdOrganizacionManualRoute
  "/_authed-tw/solicitudes/$id/prorrateo": typeof AuthedTwSolicitudesIdProrrateoRoute
  "/_authed-tw/solicitudes/$id/prorrateo-multiple": typeof AuthedTwSolicitudesIdProrrateoMultipleRoute
  "/_authed-tw/solicitudes/$id/prorrateo-sin-cfdi": typeof AuthedTwSolicitudesIdProrrateoSinCfdiRoute
  "/_authed-tw/solicitudes/$id/proveedor": typeof AuthedTwSolicitudesIdProveedorRoute
  "/_authed-tw/solicitudes/$id/proveedor-manual": typeof AuthedTwSolicitudesIdProveedorManualRoute
  "/_authed-tw/admin/contratos-anualizados/": typeof AuthedTwAdminContratosAnualizadosIndexRoute
  "/_authed-tw/admin/ordenes-compra/": typeof AuthedTwAdminOrdenesCompraIndexRoute
  "/_authed-tw/solicitudes/$id/": typeof AuthedTwSolicitudesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/login"
    | "/recuperar-contrasena"
    | "/restablecer-contrasena"
    | "/calendario-pagos"
    | "/contrapagos-pendientes"
    | "/dashboard"
    | "/facturas"
    | "/historico-documental"
    | "/perfil"
    | "/reporteria"
    | "/admin/areas"
    | "/admin/auditoria"
    | "/admin/catalogos-contables"
    | "/admin/catalogos-sat"
    | "/admin/categorias-documento"
    | "/admin/configuraciones"
    | "/admin/equivalencias-unidad"
    | "/admin/flujos-autorizacion"
    | "/admin/indicadores-impuesto"
    | "/admin/mapeos-clave-cuenta"
    | "/admin/organizaciones"
    | "/admin/permisos"
    | "/admin/proveedores"
    | "/admin/reporteria"
    | "/admin/roles"
    | "/admin/solicitudes-catalogo"
    | "/admin/tipos-documento"
    | "/admin/usuarios"
    | "/autorizacion/$id"
    | "/autorizacion/bandeja"
    | "/autorizacion/historial"
    | "/solicitudes/nueva"
    | "/admin/"
    | "/solicitudes/"
    | "/admin/contratos-anualizados/$id"
    | "/admin/ordenes-compra/$id"
    | "/solicitudes/$id/autorizacion"
    | "/solicitudes/$id/carga-invoice"
    | "/solicitudes/$id/cargar-cfdi"
    | "/solicitudes/$id/cargar-zip"
    | "/solicitudes/$id/conciliar-cfdi"
    | "/solicitudes/$id/contabilizacion"
    | "/solicitudes/$id/contrato-anualizado"
    | "/solicitudes/$id/datos-generales"
    | "/solicitudes/$id/documentos"
    | "/solicitudes/$id/historial"
    | "/solicitudes/$id/orden-compra"
    | "/solicitudes/$id/organizacion-manual"
    | "/solicitudes/$id/prorrateo"
    | "/solicitudes/$id/prorrateo-multiple"
    | "/solicitudes/$id/prorrateo-sin-cfdi"
    | "/solicitudes/$id/proveedor"
    | "/solicitudes/$id/proveedor-manual"
    | "/admin/contratos-anualizados/"
    | "/admin/ordenes-compra/"
    | "/solicitudes/$id/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/login"
    | "/recuperar-contrasena"
    | "/restablecer-contrasena"
    | "/calendario-pagos"
    | "/contrapagos-pendientes"
    | "/dashboard"
    | "/facturas"
    | "/historico-documental"
    | "/perfil"
    | "/reporteria"
    | "/admin/areas"
    | "/admin/auditoria"
    | "/admin/catalogos-contables"
    | "/admin/catalogos-sat"
    | "/admin/categorias-documento"
    | "/admin/configuraciones"
    | "/admin/equivalencias-unidad"
    | "/admin/flujos-autorizacion"
    | "/admin/indicadores-impuesto"
    | "/admin/mapeos-clave-cuenta"
    | "/admin/organizaciones"
    | "/admin/permisos"
    | "/admin/proveedores"
    | "/admin/reporteria"
    | "/admin/roles"
    | "/admin/solicitudes-catalogo"
    | "/admin/tipos-documento"
    | "/admin/usuarios"
    | "/autorizacion/$id"
    | "/autorizacion/bandeja"
    | "/autorizacion/historial"
    | "/solicitudes/nueva"
    | "/admin"
    | "/solicitudes"
    | "/admin/contratos-anualizados/$id"
    | "/admin/ordenes-compra/$id"
    | "/solicitudes/$id/autorizacion"
    | "/solicitudes/$id/carga-invoice"
    | "/solicitudes/$id/cargar-cfdi"
    | "/solicitudes/$id/cargar-zip"
    | "/solicitudes/$id/conciliar-cfdi"
    | "/solicitudes/$id/contabilizacion"
    | "/solicitudes/$id/contrato-anualizado"
    | "/solicitudes/$id/datos-generales"
    | "/solicitudes/$id/documentos"
    | "/solicitudes/$id/historial"
    | "/solicitudes/$id/orden-compra"
    | "/solicitudes/$id/organizacion-manual"
    | "/solicitudes/$id/prorrateo"
    | "/solicitudes/$id/prorrateo-multiple"
    | "/solicitudes/$id/prorrateo-sin-cfdi"
    | "/solicitudes/$id/proveedor"
    | "/solicitudes/$id/proveedor-manual"
    | "/admin/contratos-anualizados"
    | "/admin/ordenes-compra"
    | "/solicitudes/$id"
  id:
    | "__root__"
    | "/"
    | "/_authed-tw"
    | "/login"
    | "/recuperar-contrasena"
    | "/restablecer-contrasena"
    | "/_authed-tw/calendario-pagos"
    | "/_authed-tw/contrapagos-pendientes"
    | "/_authed-tw/dashboard"
    | "/_authed-tw/facturas"
    | "/_authed-tw/historico-documental"
    | "/_authed-tw/perfil"
    | "/_authed-tw/reporteria"
    | "/_authed-tw/admin/areas"
    | "/_authed-tw/admin/auditoria"
    | "/_authed-tw/admin/catalogos-contables"
    | "/_authed-tw/admin/catalogos-sat"
    | "/_authed-tw/admin/categorias-documento"
    | "/_authed-tw/admin/configuraciones"
    | "/_authed-tw/admin/equivalencias-unidad"
    | "/_authed-tw/admin/flujos-autorizacion"
    | "/_authed-tw/admin/indicadores-impuesto"
    | "/_authed-tw/admin/mapeos-clave-cuenta"
    | "/_authed-tw/admin/organizaciones"
    | "/_authed-tw/admin/permisos"
    | "/_authed-tw/admin/proveedores"
    | "/_authed-tw/admin/reporteria"
    | "/_authed-tw/admin/roles"
    | "/_authed-tw/admin/solicitudes-catalogo"
    | "/_authed-tw/admin/tipos-documento"
    | "/_authed-tw/admin/usuarios"
    | "/_authed-tw/autorizacion/$id"
    | "/_authed-tw/autorizacion/bandeja"
    | "/_authed-tw/autorizacion/historial"
    | "/_authed-tw/solicitudes/nueva"
    | "/_authed-tw/admin/"
    | "/_authed-tw/solicitudes/"
    | "/_authed-tw/admin/contratos-anualizados/$id"
    | "/_authed-tw/admin/ordenes-compra/$id"
    | "/_authed-tw/solicitudes/$id/autorizacion"
    | "/_authed-tw/solicitudes/$id/carga-invoice"
    | "/_authed-tw/solicitudes/$id/cargar-cfdi"
    | "/_authed-tw/solicitudes/$id/cargar-zip"
    | "/_authed-tw/solicitudes/$id/conciliar-cfdi"
    | "/_authed-tw/solicitudes/$id/contabilizacion"
    | "/_authed-tw/solicitudes/$id/contrato-anualizado"
    | "/_authed-tw/solicitudes/$id/datos-generales"
    | "/_authed-tw/solicitudes/$id/documentos"
    | "/_authed-tw/solicitudes/$id/historial"
    | "/_authed-tw/solicitudes/$id/orden-compra"
    | "/_authed-tw/solicitudes/$id/organizacion-manual"
    | "/_authed-tw/solicitudes/$id/prorrateo"
    | "/_authed-tw/solicitudes/$id/prorrateo-multiple"
    | "/_authed-tw/solicitudes/$id/prorrateo-sin-cfdi"
    | "/_authed-tw/solicitudes/$id/proveedor"
    | "/_authed-tw/solicitudes/$id/proveedor-manual"
    | "/_authed-tw/admin/contratos-anualizados/"
    | "/_authed-tw/admin/ordenes-compra/"
    | "/_authed-tw/solicitudes/$id/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedTwRoute: typeof AuthedTwRouteWithChildren
  LoginRoute: typeof LoginRoute
  RecuperarContrasenaRoute: typeof RecuperarContrasenaRoute
  RestablecerContrasenaRoute: typeof RestablecerContrasenaRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/restablecer-contrasena": {
      id: "/restablecer-contrasena"
      path: "/restablecer-contrasena"
      fullPath: "/restablecer-contrasena"
      preLoaderRoute: typeof RestablecerContrasenaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/recuperar-contrasena": {
      id: "/recuperar-contrasena"
      path: "/recuperar-contrasena"
      fullPath: "/recuperar-contrasena"
      preLoaderRoute: typeof RecuperarContrasenaRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed-tw": {
      id: "/_authed-tw"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AuthedTwRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_authed-tw/reporteria": {
      id: "/_authed-tw/reporteria"
      path: "/reporteria"
      fullPath: "/reporteria"
      preLoaderRoute: typeof AuthedTwReporteriaRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/perfil": {
      id: "/_authed-tw/perfil"
      path: "/perfil"
      fullPath: "/perfil"
      preLoaderRoute: typeof AuthedTwPerfilRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/historico-documental": {
      id: "/_authed-tw/historico-documental"
      path: "/historico-documental"
      fullPath: "/historico-documental"
      preLoaderRoute: typeof AuthedTwHistoricoDocumentalRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/facturas": {
      id: "/_authed-tw/facturas"
      path: "/facturas"
      fullPath: "/facturas"
      preLoaderRoute: typeof AuthedTwFacturasRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/dashboard": {
      id: "/_authed-tw/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof AuthedTwDashboardRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/contrapagos-pendientes": {
      id: "/_authed-tw/contrapagos-pendientes"
      path: "/contrapagos-pendientes"
      fullPath: "/contrapagos-pendientes"
      preLoaderRoute: typeof AuthedTwContrapagosPendientesRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/calendario-pagos": {
      id: "/_authed-tw/calendario-pagos"
      path: "/calendario-pagos"
      fullPath: "/calendario-pagos"
      preLoaderRoute: typeof AuthedTwCalendarioPagosRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/": {
      id: "/_authed-tw/solicitudes/"
      path: "/solicitudes"
      fullPath: "/solicitudes/"
      preLoaderRoute: typeof AuthedTwSolicitudesIndexRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/": {
      id: "/_authed-tw/admin/"
      path: "/admin"
      fullPath: "/admin/"
      preLoaderRoute: typeof AuthedTwAdminIndexRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/nueva": {
      id: "/_authed-tw/solicitudes/nueva"
      path: "/solicitudes/nueva"
      fullPath: "/solicitudes/nueva"
      preLoaderRoute: typeof AuthedTwSolicitudesNuevaRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/autorizacion/historial": {
      id: "/_authed-tw/autorizacion/historial"
      path: "/autorizacion/historial"
      fullPath: "/autorizacion/historial"
      preLoaderRoute: typeof AuthedTwAutorizacionHistorialRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/autorizacion/bandeja": {
      id: "/_authed-tw/autorizacion/bandeja"
      path: "/autorizacion/bandeja"
      fullPath: "/autorizacion/bandeja"
      preLoaderRoute: typeof AuthedTwAutorizacionBandejaRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/autorizacion/$id": {
      id: "/_authed-tw/autorizacion/$id"
      path: "/autorizacion/$id"
      fullPath: "/autorizacion/$id"
      preLoaderRoute: typeof AuthedTwAutorizacionIdRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/usuarios": {
      id: "/_authed-tw/admin/usuarios"
      path: "/admin/usuarios"
      fullPath: "/admin/usuarios"
      preLoaderRoute: typeof AuthedTwAdminUsuariosRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/tipos-documento": {
      id: "/_authed-tw/admin/tipos-documento"
      path: "/admin/tipos-documento"
      fullPath: "/admin/tipos-documento"
      preLoaderRoute: typeof AuthedTwAdminTiposDocumentoRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/solicitudes-catalogo": {
      id: "/_authed-tw/admin/solicitudes-catalogo"
      path: "/admin/solicitudes-catalogo"
      fullPath: "/admin/solicitudes-catalogo"
      preLoaderRoute: typeof AuthedTwAdminSolicitudesCatalogoRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/roles": {
      id: "/_authed-tw/admin/roles"
      path: "/admin/roles"
      fullPath: "/admin/roles"
      preLoaderRoute: typeof AuthedTwAdminRolesRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/reporteria": {
      id: "/_authed-tw/admin/reporteria"
      path: "/admin/reporteria"
      fullPath: "/admin/reporteria"
      preLoaderRoute: typeof AuthedTwAdminReporteriaRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/proveedores": {
      id: "/_authed-tw/admin/proveedores"
      path: "/admin/proveedores"
      fullPath: "/admin/proveedores"
      preLoaderRoute: typeof AuthedTwAdminProveedoresRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/permisos": {
      id: "/_authed-tw/admin/permisos"
      path: "/admin/permisos"
      fullPath: "/admin/permisos"
      preLoaderRoute: typeof AuthedTwAdminPermisosRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/organizaciones": {
      id: "/_authed-tw/admin/organizaciones"
      path: "/admin/organizaciones"
      fullPath: "/admin/organizaciones"
      preLoaderRoute: typeof AuthedTwAdminOrganizacionesRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/mapeos-clave-cuenta": {
      id: "/_authed-tw/admin/mapeos-clave-cuenta"
      path: "/admin/mapeos-clave-cuenta"
      fullPath: "/admin/mapeos-clave-cuenta"
      preLoaderRoute: typeof AuthedTwAdminMapeosClaveCuentaRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/indicadores-impuesto": {
      id: "/_authed-tw/admin/indicadores-impuesto"
      path: "/admin/indicadores-impuesto"
      fullPath: "/admin/indicadores-impuesto"
      preLoaderRoute: typeof AuthedTwAdminIndicadoresImpuestoRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/flujos-autorizacion": {
      id: "/_authed-tw/admin/flujos-autorizacion"
      path: "/admin/flujos-autorizacion"
      fullPath: "/admin/flujos-autorizacion"
      preLoaderRoute: typeof AuthedTwAdminFlujosAutorizacionRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/equivalencias-unidad": {
      id: "/_authed-tw/admin/equivalencias-unidad"
      path: "/admin/equivalencias-unidad"
      fullPath: "/admin/equivalencias-unidad"
      preLoaderRoute: typeof AuthedTwAdminEquivalenciasUnidadRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/configuraciones": {
      id: "/_authed-tw/admin/configuraciones"
      path: "/admin/configuraciones"
      fullPath: "/admin/configuraciones"
      preLoaderRoute: typeof AuthedTwAdminConfiguracionesRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/categorias-documento": {
      id: "/_authed-tw/admin/categorias-documento"
      path: "/admin/categorias-documento"
      fullPath: "/admin/categorias-documento"
      preLoaderRoute: typeof AuthedTwAdminCategoriasDocumentoRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/catalogos-sat": {
      id: "/_authed-tw/admin/catalogos-sat"
      path: "/admin/catalogos-sat"
      fullPath: "/admin/catalogos-sat"
      preLoaderRoute: typeof AuthedTwAdminCatalogosSatRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/catalogos-contables": {
      id: "/_authed-tw/admin/catalogos-contables"
      path: "/admin/catalogos-contables"
      fullPath: "/admin/catalogos-contables"
      preLoaderRoute: typeof AuthedTwAdminCatalogosContablesRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/auditoria": {
      id: "/_authed-tw/admin/auditoria"
      path: "/admin/auditoria"
      fullPath: "/admin/auditoria"
      preLoaderRoute: typeof AuthedTwAdminAuditoriaRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/areas": {
      id: "/_authed-tw/admin/areas"
      path: "/admin/areas"
      fullPath: "/admin/areas"
      preLoaderRoute: typeof AuthedTwAdminAreasRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/": {
      id: "/_authed-tw/solicitudes/$id/"
      path: "/solicitudes/$id"
      fullPath: "/solicitudes/$id/"
      preLoaderRoute: typeof AuthedTwSolicitudesIdIndexRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/ordenes-compra/": {
      id: "/_authed-tw/admin/ordenes-compra/"
      path: "/admin/ordenes-compra"
      fullPath: "/admin/ordenes-compra/"
      preLoaderRoute: typeof AuthedTwAdminOrdenesCompraIndexRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/contratos-anualizados/": {
      id: "/_authed-tw/admin/contratos-anualizados/"
      path: "/admin/contratos-anualizados"
      fullPath: "/admin/contratos-anualizados/"
      preLoaderRoute: typeof AuthedTwAdminContratosAnualizadosIndexRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/proveedor-manual": {
      id: "/_authed-tw/solicitudes/$id/proveedor-manual"
      path: "/solicitudes/$id/proveedor-manual"
      fullPath: "/solicitudes/$id/proveedor-manual"
      preLoaderRoute: typeof AuthedTwSolicitudesIdProveedorManualRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/proveedor": {
      id: "/_authed-tw/solicitudes/$id/proveedor"
      path: "/solicitudes/$id/proveedor"
      fullPath: "/solicitudes/$id/proveedor"
      preLoaderRoute: typeof AuthedTwSolicitudesIdProveedorRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/prorrateo-sin-cfdi": {
      id: "/_authed-tw/solicitudes/$id/prorrateo-sin-cfdi"
      path: "/solicitudes/$id/prorrateo-sin-cfdi"
      fullPath: "/solicitudes/$id/prorrateo-sin-cfdi"
      preLoaderRoute: typeof AuthedTwSolicitudesIdProrrateoSinCfdiRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/prorrateo-multiple": {
      id: "/_authed-tw/solicitudes/$id/prorrateo-multiple"
      path: "/solicitudes/$id/prorrateo-multiple"
      fullPath: "/solicitudes/$id/prorrateo-multiple"
      preLoaderRoute: typeof AuthedTwSolicitudesIdProrrateoMultipleRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/prorrateo": {
      id: "/_authed-tw/solicitudes/$id/prorrateo"
      path: "/solicitudes/$id/prorrateo"
      fullPath: "/solicitudes/$id/prorrateo"
      preLoaderRoute: typeof AuthedTwSolicitudesIdProrrateoRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/organizacion-manual": {
      id: "/_authed-tw/solicitudes/$id/organizacion-manual"
      path: "/solicitudes/$id/organizacion-manual"
      fullPath: "/solicitudes/$id/organizacion-manual"
      preLoaderRoute: typeof AuthedTwSolicitudesIdOrganizacionManualRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/orden-compra": {
      id: "/_authed-tw/solicitudes/$id/orden-compra"
      path: "/solicitudes/$id/orden-compra"
      fullPath: "/solicitudes/$id/orden-compra"
      preLoaderRoute: typeof AuthedTwSolicitudesIdOrdenCompraRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/historial": {
      id: "/_authed-tw/solicitudes/$id/historial"
      path: "/solicitudes/$id/historial"
      fullPath: "/solicitudes/$id/historial"
      preLoaderRoute: typeof AuthedTwSolicitudesIdHistorialRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/documentos": {
      id: "/_authed-tw/solicitudes/$id/documentos"
      path: "/solicitudes/$id/documentos"
      fullPath: "/solicitudes/$id/documentos"
      preLoaderRoute: typeof AuthedTwSolicitudesIdDocumentosRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/datos-generales": {
      id: "/_authed-tw/solicitudes/$id/datos-generales"
      path: "/solicitudes/$id/datos-generales"
      fullPath: "/solicitudes/$id/datos-generales"
      preLoaderRoute: typeof AuthedTwSolicitudesIdDatosGeneralesRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/contrato-anualizado": {
      id: "/_authed-tw/solicitudes/$id/contrato-anualizado"
      path: "/solicitudes/$id/contrato-anualizado"
      fullPath: "/solicitudes/$id/contrato-anualizado"
      preLoaderRoute: typeof AuthedTwSolicitudesIdContratoAnualizadoRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/contabilizacion": {
      id: "/_authed-tw/solicitudes/$id/contabilizacion"
      path: "/solicitudes/$id/contabilizacion"
      fullPath: "/solicitudes/$id/contabilizacion"
      preLoaderRoute: typeof AuthedTwSolicitudesIdContabilizacionRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/conciliar-cfdi": {
      id: "/_authed-tw/solicitudes/$id/conciliar-cfdi"
      path: "/solicitudes/$id/conciliar-cfdi"
      fullPath: "/solicitudes/$id/conciliar-cfdi"
      preLoaderRoute: typeof AuthedTwSolicitudesIdConciliarCfdiRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/cargar-zip": {
      id: "/_authed-tw/solicitudes/$id/cargar-zip"
      path: "/solicitudes/$id/cargar-zip"
      fullPath: "/solicitudes/$id/cargar-zip"
      preLoaderRoute: typeof AuthedTwSolicitudesIdCargarZipRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/cargar-cfdi": {
      id: "/_authed-tw/solicitudes/$id/cargar-cfdi"
      path: "/solicitudes/$id/cargar-cfdi"
      fullPath: "/solicitudes/$id/cargar-cfdi"
      preLoaderRoute: typeof AuthedTwSolicitudesIdCargarCfdiRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/carga-invoice": {
      id: "/_authed-tw/solicitudes/$id/carga-invoice"
      path: "/solicitudes/$id/carga-invoice"
      fullPath: "/solicitudes/$id/carga-invoice"
      preLoaderRoute: typeof AuthedTwSolicitudesIdCargaInvoiceRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/solicitudes/$id/autorizacion": {
      id: "/_authed-tw/solicitudes/$id/autorizacion"
      path: "/solicitudes/$id/autorizacion"
      fullPath: "/solicitudes/$id/autorizacion"
      preLoaderRoute: typeof AuthedTwSolicitudesIdAutorizacionRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/ordenes-compra/$id": {
      id: "/_authed-tw/admin/ordenes-compra/$id"
      path: "/admin/ordenes-compra/$id"
      fullPath: "/admin/ordenes-compra/$id"
      preLoaderRoute: typeof AuthedTwAdminOrdenesCompraIdRouteImport
      parentRoute: typeof AuthedTwRoute
    }
    "/_authed-tw/admin/contratos-anualizados/$id": {
      id: "/_authed-tw/admin/contratos-anualizados/$id"
      path: "/admin/contratos-anualizados/$id"
      fullPath: "/admin/contratos-anualizados/$id"
      preLoaderRoute: typeof AuthedTwAdminContratosAnualizadosIdRouteImport
      parentRoute: typeof AuthedTwRoute
    }
  }
}

interface AuthedTwRouteChildren {
  AuthedTwCalendarioPagosRoute: typeof AuthedTwCalendarioPagosRoute
  AuthedTwContrapagosPendientesRoute: typeof AuthedTwContrapagosPendientesRoute
  AuthedTwDashboardRoute: typeof AuthedTwDashboardRoute
  AuthedTwFacturasRoute: typeof AuthedTwFacturasRoute
  AuthedTwHistoricoDocumentalRoute: typeof AuthedTwHistoricoDocumentalRoute
  AuthedTwPerfilRoute: typeof AuthedTwPerfilRoute
  AuthedTwReporteriaRoute: typeof AuthedTwReporteriaRoute
  AuthedTwAdminAreasRoute: typeof AuthedTwAdminAreasRoute
  AuthedTwAdminAuditoriaRoute: typeof AuthedTwAdminAuditoriaRoute
  AuthedTwAdminCatalogosContablesRoute: typeof AuthedTwAdminCatalogosContablesRoute
  AuthedTwAdminCatalogosSatRoute: typeof AuthedTwAdminCatalogosSatRoute
  AuthedTwAdminCategoriasDocumentoRoute: typeof AuthedTwAdminCategoriasDocumentoRoute
  AuthedTwAdminConfiguracionesRoute: typeof AuthedTwAdminConfiguracionesRoute
  AuthedTwAdminEquivalenciasUnidadRoute: typeof AuthedTwAdminEquivalenciasUnidadRoute
  AuthedTwAdminFlujosAutorizacionRoute: typeof AuthedTwAdminFlujosAutorizacionRoute
  AuthedTwAdminIndicadoresImpuestoRoute: typeof AuthedTwAdminIndicadoresImpuestoRoute
  AuthedTwAdminMapeosClaveCuentaRoute: typeof AuthedTwAdminMapeosClaveCuentaRoute
  AuthedTwAdminOrganizacionesRoute: typeof AuthedTwAdminOrganizacionesRoute
  AuthedTwAdminPermisosRoute: typeof AuthedTwAdminPermisosRoute
  AuthedTwAdminProveedoresRoute: typeof AuthedTwAdminProveedoresRoute
  AuthedTwAdminReporteriaRoute: typeof AuthedTwAdminReporteriaRoute
  AuthedTwAdminRolesRoute: typeof AuthedTwAdminRolesRoute
  AuthedTwAdminSolicitudesCatalogoRoute: typeof AuthedTwAdminSolicitudesCatalogoRoute
  AuthedTwAdminTiposDocumentoRoute: typeof AuthedTwAdminTiposDocumentoRoute
  AuthedTwAdminUsuariosRoute: typeof AuthedTwAdminUsuariosRoute
  AuthedTwAutorizacionIdRoute: typeof AuthedTwAutorizacionIdRoute
  AuthedTwAutorizacionBandejaRoute: typeof AuthedTwAutorizacionBandejaRoute
  AuthedTwAutorizacionHistorialRoute: typeof AuthedTwAutorizacionHistorialRoute
  AuthedTwSolicitudesNuevaRoute: typeof AuthedTwSolicitudesNuevaRoute
  AuthedTwAdminIndexRoute: typeof AuthedTwAdminIndexRoute
  AuthedTwSolicitudesIndexRoute: typeof AuthedTwSolicitudesIndexRoute
  AuthedTwAdminContratosAnualizadosIdRoute: typeof AuthedTwAdminContratosAnualizadosIdRoute
  AuthedTwAdminOrdenesCompraIdRoute: typeof AuthedTwAdminOrdenesCompraIdRoute
  AuthedTwSolicitudesIdAutorizacionRoute: typeof AuthedTwSolicitudesIdAutorizacionRoute
  AuthedTwSolicitudesIdCargaInvoiceRoute: typeof AuthedTwSolicitudesIdCargaInvoiceRoute
  AuthedTwSolicitudesIdCargarCfdiRoute: typeof AuthedTwSolicitudesIdCargarCfdiRoute
  AuthedTwSolicitudesIdCargarZipRoute: typeof AuthedTwSolicitudesIdCargarZipRoute
  AuthedTwSolicitudesIdConciliarCfdiRoute: typeof AuthedTwSolicitudesIdConciliarCfdiRoute
  AuthedTwSolicitudesIdContabilizacionRoute: typeof AuthedTwSolicitudesIdContabilizacionRoute
  AuthedTwSolicitudesIdContratoAnualizadoRoute: typeof AuthedTwSolicitudesIdContratoAnualizadoRoute
  AuthedTwSolicitudesIdDatosGeneralesRoute: typeof AuthedTwSolicitudesIdDatosGeneralesRoute
  AuthedTwSolicitudesIdDocumentosRoute: typeof AuthedTwSolicitudesIdDocumentosRoute
  AuthedTwSolicitudesIdHistorialRoute: typeof AuthedTwSolicitudesIdHistorialRoute
  AuthedTwSolicitudesIdOrdenCompraRoute: typeof AuthedTwSolicitudesIdOrdenCompraRoute
  AuthedTwSolicitudesIdOrganizacionManualRoute: typeof AuthedTwSolicitudesIdOrganizacionManualRoute
  AuthedTwSolicitudesIdProrrateoRoute: typeof AuthedTwSolicitudesIdProrrateoRoute
  AuthedTwSolicitudesIdProrrateoMultipleRoute: typeof AuthedTwSolicitudesIdProrrateoMultipleRoute
  AuthedTwSolicitudesIdProrrateoSinCfdiRoute: typeof AuthedTwSolicitudesIdProrrateoSinCfdiRoute
  AuthedTwSolicitudesIdProveedorRoute: typeof AuthedTwSolicitudesIdProveedorRoute
  AuthedTwSolicitudesIdProveedorManualRoute: typeof AuthedTwSolicitudesIdProveedorManualRoute
  AuthedTwAdminContratosAnualizadosIndexRoute: typeof AuthedTwAdminContratosAnualizadosIndexRoute
  AuthedTwAdminOrdenesCompraIndexRoute: typeof AuthedTwAdminOrdenesCompraIndexRoute
  AuthedTwSolicitudesIdIndexRoute: typeof AuthedTwSolicitudesIdIndexRoute
}

const AuthedTwRouteChildren: AuthedTwRouteChildren = {
  AuthedTwCalendarioPagosRoute: AuthedTwCalendarioPagosRoute,
  AuthedTwContrapagosPendientesRoute: AuthedTwContrapagosPendientesRoute,
  AuthedTwDashboardRoute: AuthedTwDashboardRoute,
  AuthedTwFacturasRoute: AuthedTwFacturasRoute,
  AuthedTwHistoricoDocumentalRoute: AuthedTwHistoricoDocumentalRoute,
  AuthedTwPerfilRoute: AuthedTwPerfilRoute,
  AuthedTwReporteriaRoute: AuthedTwReporteriaRoute,
  AuthedTwAdminAreasRoute: AuthedTwAdminAreasRoute,
  AuthedTwAdminAuditoriaRoute: AuthedTwAdminAuditoriaRoute,
  AuthedTwAdminCatalogosContablesRoute: AuthedTwAdminCatalogosContablesRoute,
  AuthedTwAdminCatalogosSatRoute: AuthedTwAdminCatalogosSatRoute,
  AuthedTwAdminCategoriasDocumentoRoute: AuthedTwAdminCategoriasDocumentoRoute,
  AuthedTwAdminConfiguracionesRoute: AuthedTwAdminConfiguracionesRoute,
  AuthedTwAdminEquivalenciasUnidadRoute: AuthedTwAdminEquivalenciasUnidadRoute,
  AuthedTwAdminFlujosAutorizacionRoute: AuthedTwAdminFlujosAutorizacionRoute,
  AuthedTwAdminIndicadoresImpuestoRoute: AuthedTwAdminIndicadoresImpuestoRoute,
  AuthedTwAdminMapeosClaveCuentaRoute: AuthedTwAdminMapeosClaveCuentaRoute,
  AuthedTwAdminOrganizacionesRoute: AuthedTwAdminOrganizacionesRoute,
  AuthedTwAdminPermisosRoute: AuthedTwAdminPermisosRoute,
  AuthedTwAdminProveedoresRoute: AuthedTwAdminProveedoresRoute,
  AuthedTwAdminReporteriaRoute: AuthedTwAdminReporteriaRoute,
  AuthedTwAdminRolesRoute: AuthedTwAdminRolesRoute,
  AuthedTwAdminSolicitudesCatalogoRoute: AuthedTwAdminSolicitudesCatalogoRoute,
  AuthedTwAdminTiposDocumentoRoute: AuthedTwAdminTiposDocumentoRoute,
  AuthedTwAdminUsuariosRoute: AuthedTwAdminUsuariosRoute,
  AuthedTwAutorizacionIdRoute: AuthedTwAutorizacionIdRoute,
  AuthedTwAutorizacionBandejaRoute: AuthedTwAutorizacionBandejaRoute,
  AuthedTwAutorizacionHistorialRoute: AuthedTwAutorizacionHistorialRoute,
  AuthedTwSolicitudesNuevaRoute: AuthedTwSolicitudesNuevaRoute,
  AuthedTwAdminIndexRoute: AuthedTwAdminIndexRoute,
  AuthedTwSolicitudesIndexRoute: AuthedTwSolicitudesIndexRoute,
  AuthedTwAdminContratosAnualizadosIdRoute:
    AuthedTwAdminContratosAnualizadosIdRoute,
  AuthedTwAdminOrdenesCompraIdRoute: AuthedTwAdminOrdenesCompraIdRoute,
  AuthedTwSolicitudesIdAutorizacionRoute:
    AuthedTwSolicitudesIdAutorizacionRoute,
  AuthedTwSolicitudesIdCargaInvoiceRoute:
    AuthedTwSolicitudesIdCargaInvoiceRoute,
  AuthedTwSolicitudesIdCargarCfdiRoute: AuthedTwSolicitudesIdCargarCfdiRoute,
  AuthedTwSolicitudesIdCargarZipRoute: AuthedTwSolicitudesIdCargarZipRoute,
  AuthedTwSolicitudesIdConciliarCfdiRoute:
    AuthedTwSolicitudesIdConciliarCfdiRoute,
  AuthedTwSolicitudesIdContabilizacionRoute:
    AuthedTwSolicitudesIdContabilizacionRoute,
  AuthedTwSolicitudesIdContratoAnualizadoRoute:
    AuthedTwSolicitudesIdContratoAnualizadoRoute,
  AuthedTwSolicitudesIdDatosGeneralesRoute:
    AuthedTwSolicitudesIdDatosGeneralesRoute,
  AuthedTwSolicitudesIdDocumentosRoute: AuthedTwSolicitudesIdDocumentosRoute,
  AuthedTwSolicitudesIdHistorialRoute: AuthedTwSolicitudesIdHistorialRoute,
  AuthedTwSolicitudesIdOrdenCompraRoute: AuthedTwSolicitudesIdOrdenCompraRoute,
  AuthedTwSolicitudesIdOrganizacionManualRoute:
    AuthedTwSolicitudesIdOrganizacionManualRoute,
  AuthedTwSolicitudesIdProrrateoRoute: AuthedTwSolicitudesIdProrrateoRoute,
  AuthedTwSolicitudesIdProrrateoMultipleRoute:
    AuthedTwSolicitudesIdProrrateoMultipleRoute,
  AuthedTwSolicitudesIdProrrateoSinCfdiRoute:
    AuthedTwSolicitudesIdProrrateoSinCfdiRoute,
  AuthedTwSolicitudesIdProveedorRoute: AuthedTwSolicitudesIdProveedorRoute,
  AuthedTwSolicitudesIdProveedorManualRoute:
    AuthedTwSolicitudesIdProveedorManualRoute,
  AuthedTwAdminContratosAnualizadosIndexRoute:
    AuthedTwAdminContratosAnualizadosIndexRoute,
  AuthedTwAdminOrdenesCompraIndexRoute: AuthedTwAdminOrdenesCompraIndexRoute,
  AuthedTwSolicitudesIdIndexRoute: AuthedTwSolicitudesIdIndexRoute,
}

const AuthedTwRouteWithChildren = AuthedTwRoute._addFileChildren(
  AuthedTwRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedTwRoute: AuthedTwRouteWithChildren,
  LoginRoute: LoginRoute,
  RecuperarContrasenaRoute: RecuperarContrasenaRoute,
  RestablecerContrasenaRoute: RestablecerContrasenaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
